// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Typography } from '@mui/material';
import CopyToClipboard from './CopyToClipboard';

const DataDisplay = ({ data }: { data: string }) => {
  return (
    <CopyToClipboard buttonClassName="copy-button" tooltipText="Copy to clipboard" value={data}>
      <Typography color="textPrimary" variant="body2">
        {data}
      </Typography>
    </CopyToClipboard>
  );
};

export default DataDisplay;
